import { gql } from '@apollo/client';

export const CREATE_CERTIFICATE_TEMPLATE = gql`
mutation($input: CreateCertificateTemplateInput!) { 
    result: createCertificateTemplate(input: $input) { 
      id
      name
      description
      templateKey
      certificateProfile {
        id
        name
        description
      }
      brand {
        id
        name
      }
    } 
  }

`;